import COM from './JumpLink'

export default COM



// WEBPACK FOOTER //
// ./src/js/_core/components/JumpLink/index.jsx